import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, ListChecks, ArrowRight } from "lucide-react";

const LEVEL_COLOR = {
  1: "bg-rose-500",
  2: "bg-orange-400",
  3: "bg-amber-400",
  4: "bg-emerald-500",
  5: "bg-emerald-600",
};
const LEVEL_LABEL = { 1: "Ad hoc", 2: "Repeatable", 3: "Defined", 4: "Managed", 5: "Optimising" };

function ScoreCard({ to, icon: Icon, label, data, testid }) {
  const s = data?.scorecard;
  const lvl = s?.overall_level || 0;
  return (
    <Link to={to} data-testid={testid}
          className="group rounded-md border border-black/5 bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-ek-purple/20 hover:shadow-md flex items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="flex items-center gap-2 text-ek-ink/65">
          <Icon size={15} className="text-ek-purple" />
          <span className="text-[0.7rem] font-semibold uppercase tracking-wide">{label}</span>
        </div>
        {s ? (
          <>
            <div className="mt-2 flex items-baseline gap-2">
              <span className="font-display text-3xl font-bold text-ek-ink">L{s.overall_level}</span>
              <span className="text-sm font-semibold text-ek-ink/70">{s.overall_level_label}</span>
            </div>
            <p className="mt-1 text-xs text-ek-ink/65">
              Composite <strong>{s.overall_score.toFixed(2)}</strong> · {s.sample_size} item(s) · {s.confidence}
            </p>
          </>
        ) : (
          <p className="mt-2 text-sm text-ek-ink/40">Loading…</p>
        )}
      </div>
      <div className="flex flex-col items-end gap-2 shrink-0">
        {lvl > 0 && (
          <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium text-white ${LEVEL_COLOR[lvl]}`}>{LEVEL_LABEL[lvl]}</span>
        )}
        <ArrowRight size={14} className="text-ek-ink/30 transition-all group-hover:translate-x-0.5 group-hover:text-ek-purple" />
      </div>
    </Link>
  );
}

export function QualityCards() {
  const [rrqs, setRrqs] = useState(null);
  const [pis, setPis] = useState(null);

  useEffect(() => {
    api.get("/risk-register-quality").then(({ data }) => setRrqs(data)).catch(() => {});
    api.get("/plan-integrity").then(({ data }) => setPis(data)).catch(() => {});
  }, []);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-testid="quality-summary-cards">
      <ScoreCard to="/risk-register-quality" icon={ShieldCheck} label="Risk Register Quality" data={rrqs} testid="dashboard-rrqs-card" />
      <ScoreCard to="/plan-integrity" icon={ListChecks} label="Plan Integrity" data={pis} testid="dashboard-pis-card" />
    </div>
  );
}
